"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const SvgComponent = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 16 16",
  fill: "none",
  role: "img"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M4.3 11.48a.39.39 0 00-.19.32v.92c0 .3.34.5.6.33l1.62-.97-1.17-1.16-.87.56zm10.12-4.75l-1.37-.85c0-.34-.05-.74-.17-1.18-.27-1.03-.78-1.78-1.12-1.7-.34.1-.4 1-.12 2.03l.05.17c-.12-.14-.25-.3-.4-.44-.75-.75-1.56-1.16-1.8-.9-.26.24.15 1.05.9 1.8.3.31.62.56.9.73a1.46 1.46 0 00-.18.7c-1.25-.9-3.75-2.53-5.44-2.53-1.27 0-2.07.68-2.55 1.31-.04-.07-.07-.14-.13-.2a1.17 1.17 0 10-1.65 1.66c.4.4 1 .42 1.46.12l4.65 4.66a.8.8 0 00.55.22h3.5c.22 0 .39-.17.39-.39v-.38a.78.78 0 00-.78-.78H8.78V9.43c0-.87-.58-1.64-1.41-1.87l-1.03-.3a.39.39 0 01.21-.74l1.03.29a2.73 2.73 0 011.98 2.62V10l1.55-.78h2.51a1.38 1.38 0 00.8-2.5zm-1.36.94a.39.39 0 110-.78.39.39 0 010 .78z",
  fill: "currentColor"
}));
var _default = exports.default = SvgComponent;